module.exports = __webpack_public_path__ + "static/trailside-josh-and-ann-1d88a34ffa557aad94180afcf2aedda8.jpeg";